var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForYou(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_724_6023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_724_6023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 75C81.7708 75 88.8021 74.4531 96.0938 73.3594C103.385 72.2656 110.156 70.7292 116.406 68.75C118.49 67.9167 120.443 68.1771 122.266 69.5312C124.089 70.8854 125 72.6563 125 74.8438V119.531C125 122.135 124.245 124.505 122.734 126.641C121.224 128.776 119.271 130.312 116.875 131.25C110.937 133.229 104.297 134.766 96.9531 135.859C89.6094 136.953 82.2917 137.5 75 137.5C67.7083 137.5 60.3906 136.953 53.0469 135.859C45.7031 134.766 39.0625 133.229 33.125 131.25C30.7292 130.312 28.776 128.776 27.2656 126.641C25.7552 124.505 25 122.135 25 119.531V74.8438C25 72.6563 25.9115 70.8854 27.7344 69.5312C29.5573 68.1771 31.5104 67.9167 33.5938 68.75C39.8438 70.7292 46.6146 72.2656 53.9062 73.3594C61.1979 74.4531 68.2292 75 75 75ZM75 12.5C81.875 12.5 87.7604 14.9479 92.6562 19.8438C97.5521 24.7396 100 30.625 100 37.5C100 44.375 97.5521 50.2604 92.6562 55.1563C87.7604 60.0521 81.875 62.5 75 62.5C68.125 62.5 62.2396 60.0521 57.3438 55.1563C52.4479 50.2604 50 44.375 50 37.5C50 30.625 52.4479 24.7396 57.3438 19.8438C62.2396 14.9479 68.125 12.5 75 12.5Z",
    fill: "#CDBCAD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForYou);
export default __webpack_public_path__ + "static/media/for_you.9fe1613ad97f5981307f802f4c8ccb4f.svg";
export { ForwardRef as ReactComponent };